import { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next";
import { SocketProvider } from '../providers/SocketContext.jsx';
import { MenuProvider } from '../providers/MenuButtonsContext.jsx';

import '../translate';
import '../translate/translate';
import '../styles/style.css';
import Hello from './hello.jsx';
import Header from './game/header.jsx';
import HowToPlay from './game/howToPlay.jsx';
import GameRules from './game/GameRules.jsx';
import GameLimits from './game/GameLimits.jsx';
import ProvablyFairSettings from './game/ProvablyFairSettings.jsx'
import ProvablyFair from './game/ProvablyFair.jsx'
import FreeBets from './game/FreeBets.jsx';
import BetsHistory from './game/BetsHistory.jsx';
import InfoBoard from './game/InfoBoard.jsx';
import BetControls from './game/BetControls.jsx';
import ResultHistory from './game/ResultHistory.jsx'
import ResultHistory2 from './game/ResultHistory2.jsx'
import AvatarChangeModal from './game/AvatarChangeModal.jsx';
import FairnessModal from './game/FairnessModal.jsx';
import GameBoard from './game/GameBoard.jsx';
import { useAuth } from "../providers/AuthProvider.jsx";
import BetControlSecond from './game/BetControlSecond.jsx';
import BetControl2Hand from './game/BetControl2Hand.jsx';
import Chat from './game/Chat.jsx';
import '../styles/ProviderHeader.css';
import Navbar from './Navbar.jsx'
import Disconnect from './game/Disconnect.jsx';
import Connection from './game/Connection.jsx';
import NotifyModal from './game/NotifyModal.jsx';

function Game() {
    
    const { i18n } = useTranslation();
    const [isHowToPlayOpen, setIsHowToPlayOpen] = useState(false);
    const [isGameRulesOpen, setIsGameRulesOpen] = useState(false);
    const [isGameLimitsOpen, setIsGameLimitsOpen] = useState(false);
    const [isProvablyFairOpen, setIsProvablyFairOpen] = useState(false);
    const [isProvablyOpen, setIsProvablyOpen] = useState(false);
    const [isFreeBetsOpen, setIsFreeBetsOpen] = useState(false);
    const [isBetsHistoryOpen, setIsBetHistoryOpen] = useState(false);
    const [isAvatarChangeModalOpen, setIsAvatarChangeModalOpen] = useState(false);
    const [isFairnessOpen, setIsFairnessOpen] = useState(false)
    const [isNotifyOpen, setIsNotifyOpen] = useState(false)

    const [chatBar, setChatBar] = useState(false)
    const [connectionWrapper, setConnectionWrapper] = useState(true)
    const [disconnect, setDisconnect] = useState(false)
    const [isDepositOpen, setIsDepositOpen] = useState(false)
    const [userAvatar, setUserAvatar] = useState(null);
    const [selectedRoundId, setSelectedRoundId] = useState(null);
    const [doubleBet, setDoubleBet] = useState(() => {
        const savedValue = localStorage.getItem("doubleBet");
        return savedValue ? JSON.parse(savedValue) : false; // Парсим из строки или задаем значение по умолчанию
    });
    // Menu buttons


    //

    // user info

    const [isUserId, setIsUserId] = useState(null);
    const [isAvatar, setIsAvatar] = useState(null);
    const [isAviatorId, setIsAviatorId] = useState(null);
    const [isUserBalance, setIsUserBalance] = useState(0);
    const [userWallet, setUserWallet] = useState(null)
    const { user } = useAuth();


    useEffect(() => {
        if(!user) {
            return
        }
        setUserWallet(user.mainWallet)
        setIsUserBalance(user[`${user.mainWallet}Balance`])
        console.log(user);
    }, [user])

    useEffect(() => {
        const validateToken = async () => {
        const token = localStorage.getItem('token');
          if (!token) {
            return;
          }
    
          try {
            const response = await fetch(`${import.meta.env.VITE_API_URL}/api/validate-token`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`, // Передаем токен в заголовке
              },
            });
    
            if (response.ok) {
            const userData = await response.json()
            setIsUserId(userData.userData.id)
            setIsAvatar(userData.userData.userAvatarUrl)
            setIsAviatorId(userData.userData.aviatorId)
            
            setIsUserId(userData.userData.id)
            
            
            } 
          } catch (error) {
            console.error('Error validating token:', error);
            setIsAuthenticated(false); // В случае ошибки считаем, что токен недействителен
          }
        };
    
        validateToken();
        
      }, []);

    //





    const closeGameRules = () => {
        setTimeout(() => {
            setIsGameRulesOpen(false)
        }, 200)
    };

    const closeModal = () => {
        setTimeout(() => {
            setIsHowToPlayOpen(false)

        }, 200) // Начинаем анимацию исчезновения
    };

    const closeGameLimits = () => {
        setTimeout(() => {
            setIsGameLimitsOpen(false)
        }, 200)
    };
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    }

    const closeProvablyFair = () => {
        setTimeout(() => {
            setIsProvablyFairOpen(false)
        }, 200)
    }

    const closeProvably = () => {
        setTimeout(() => {
            setIsProvablyOpen(false)
        }, 200)
    }

    const closeFreeBets = () => {
        setTimeout(() => {
            setIsFreeBetsOpen(false);
        }, 200)
    }

    const closeBetsHistory = () => {
        setTimeout(() => {
            setIsBetHistoryOpen(false);
        }, 200)
    }

    const closeAvatarChangeModal = () => {
        setTimeout(() => {
            setIsAvatarChangeModalOpen(false);
        }, 200)
    }

    const closeFairnessModal = () => {
        setTimeout(() => {
            setIsFairnessOpen(false);
        }, 200)
    }

    const openFairnessModal = (roundId) => {
        setSelectedRoundId(roundId); // Устанавливаем roundId
        setIsFairnessOpen(true);    // Открываем модальное окно
    };

    const mainDiv = {
        width: "100%",
        height: "calc(100vh - 50px)",
        backgroundColor: "#0e0e0e",
        position: "relative",
        display: "flex",
    }
    return (
        
        <SocketProvider>
            <div className={'provider-header-wrapper'}>
                <Navbar isDepositOpen={isDepositOpen} setIsDepositOpen={setIsDepositOpen} />
            </div>
            <div style={mainDiv} className={"main-div"}>
                <div className={`main-container ${chatBar ? "chat-bar" : ""}`}>
                    <MenuProvider>
                    <Header howToPlayOpen={() => setIsHowToPlayOpen(true)} GameRulesOpen={() => setIsGameRulesOpen(true)}
                            GameLimitsOpen={() => setIsGameLimitsOpen(true)} ProvablyFairOpen={() => setIsProvablyFairOpen(true)}
                            FreeBetsOpen={() => setIsFreeBetsOpen(true)} BetsHistoryOpen={() => setIsBetHistoryOpen(true)} 
                            AvatarChangeModalOpen={() => setIsAvatarChangeModalOpen(true)} isAvatar={isAvatar} setIsAvatar={setIsAvatar}
                            isAviatorId={isAviatorId} setIsAviatorId={setIsAviatorId} isUserBalance={isUserBalance} setChatBar={setChatBar}
                            chatBar={chatBar} setIsNotifyOpen={setIsNotifyOpen}
                            
                    />
                    

                    {/* <button onClick={() => changeLanguage("en")}>English</button>*/}
                    {/*<button onClick={() => changeLanguage("ru")}>Русский</button>*/}
                    {/*<button onClick={() => changeLanguage("uz")}>O'zbekcha</button> */}
                    
                    <div className={'game-container'}>
                        <InfoBoard isUserId={isUserId} ProvablyFairOpen={() => setIsProvablyOpen(true)} setIsNotifyOpen={setIsNotifyOpen} />
                        <div className={'game-play-wrapper'}>
                            <ResultHistory2 />
                            
                            <GameBoard chatBar={chatBar} />
                            {<div className={'bet-controls-wrapper'}>
                            <BetControlSecond isUserBalance={isUserBalance} setIsUserBalance={setIsUserBalance} isUserId={isUserId} doubleBet={doubleBet} setDoubleBet={() => setDoubleBet((prev) => !prev)} userWallet={userWallet} setIsNotifyOpen={setIsNotifyOpen} />
                            <BetControl2Hand isUserBalance={isUserBalance} setIsUserBalance={setIsUserBalance} isUserId={isUserId} doubleBet={doubleBet} setDoubleBet={() => setDoubleBet((prev) => !prev)} userWallet={userWallet} setDisconnect={setDisconnect} setIsNotifyOpen={setIsNotifyOpen} />
                            </div>}
                            
                        </div>
                    </div>
                    </MenuProvider>
                </div>
                {chatBar && <Chat setChatBar={setChatBar} />}
                {isHowToPlayOpen && <HowToPlay  isOpen={isHowToPlayOpen} onClose={closeModal} GameRulesOpen={() => setIsGameRulesOpen(true)}/>}
                {isGameRulesOpen && <GameRules isOpen={isGameRulesOpen} onClose={closeGameRules} ProvablyOpen={() => setIsProvablyOpen(true)}/>}
                {isGameLimitsOpen && <GameLimits isOpen={isGameLimitsOpen} onClose={closeGameLimits} GameLimitsOpen={() => setIsGameLimitsOpen(true)} />}
                {isProvablyFairOpen && <ProvablyFairSettings isOpen={isProvablyFairOpen} onClose={closeProvablyFair} ProvablyFairOpen={() => setIsProvablyFairOpen(true)} ProvablyOpen={() => setIsProvablyOpen(true)}/>}
                {isProvablyOpen && <ProvablyFair isOpen={isProvablyOpen} onClose={closeProvably} ProvablyOpen={() => setIsProvablyOpen(true)} />}
                {isFreeBetsOpen && <FreeBets isOpen={isFreeBetsOpen} onClose={closeFreeBets} FreeBetsOpen={() => setIsFreeBetsOpen(true)} />}
                {isBetsHistoryOpen && <BetsHistory isOpen={isBetsHistoryOpen} onClose={closeBetsHistory} BetsHistoryOpen={() => setIsBetHistoryOpen(true) } isUserId={isUserId} />}
                {isAvatarChangeModalOpen && <AvatarChangeModal isOpen={isAvatarChangeModalOpen} onClose={closeAvatarChangeModal} AvatarChangeModalOpen={() => setIsAvatarChangeModalOpen(true)} isAvatar={isAvatar} setIsAvatar={setIsAvatar} />}
                {isFairnessOpen && <FairnessModal isOpen={isFairnessOpen} onClose={closeFairnessModal} />}
                {isNotifyOpen && <NotifyModal setIsDepositOpen={setIsDepositOpen} setIsNotifyOpen={setIsNotifyOpen} />}
                {disconnect && <Disconnect />}
                {connectionWrapper && <Connection setConnectionWrapper={setConnectionWrapper} />}
            </div>

        </SocketProvider>
        
    )
}

export default Game
